import { render, staticRenderFns } from "./filter-dropdown.vue?vue&type=template&id=8dec58b0&scoped=true&"
import script from "./filter-dropdown.vue?vue&type=script&lang=js&"
export * from "./filter-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./filter-dropdown.vue?vue&type=style&index=0&id=8dec58b0&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dec58b0",
  null
  
)

export default component.exports